import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SignatureFilledSvg from "@ant-design/icons-svg/es/asn/SignatureFilled";
import AntdIcon from "../components/AntdIcon";
var SignatureFilled = function SignatureFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SignatureFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SignatureFilled.displayName = 'SignatureFilled';
}
export default /*#__PURE__*/React.forwardRef(SignatureFilled);